'use client';

import React, { useContext, useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../../Context/auth/AuthContext";
import CartContext from "../../Context/Cart/CartContext";

export const Header1 = () => {
  const { autenticado, usuario } = useContext(AuthContext);
  const { cartLength } = useContext(CartContext);
  const [promo, setPromo] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [fixedNav, setFixedNav] = useState(false);
  const drawerRef = useRef(null);

  const navItems = [
    { name: "Inicio", path: "/", auth: false },
    { name: "Contactanos", path: "/contacto", auth: false },
    { name: "Distribuidores", path: "/distribuidores", auth: false },
    { name: "Comunidad", path: "/Comunidad-MC", auth: false },
    { name: "Ayuda", path: "/ayuda", auth: false },
    { name: "Inicio", path: "/", auth: true },
    { name: "Contactanos", path: "/Contacto-Merry", auth: true },
    { name: "Distribuidores", path: "/distribuidores-merry", auth: true },
    { name: "Comunidad", path: "/Comunidad", auth: true },
    { name: "Ayuda", path: "/preguntas-frecuentes", auth: true },
  ];

  const filteredNavItems = autenticado
    ? navItems.filter((item) => item.auth)
    : navItems.filter((item) => !item.auth);

  const toggleDrawer = (open) => {
    setDrawerOpen(open);
  };

  const handleScroll = () => {
    setFixedNav(window.scrollY > 10);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (drawerOpen && drawerRef.current && !drawerRef.current.contains(e.target)) {
        setDrawerOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [drawerOpen]);

  useEffect(() => {
    document.body.style.overflow = drawerOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [drawerOpen]);

  return (
    <>
      <style>{`
        @keyframes shimmerSlide {
          0% { background-position: -200% center; }
          100% { background-position: 200% center; }
        }
        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-8px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes navLinkHover {
          from { width: 0; }
          to { width: 60%; }
        }
      `}</style>

      {/* Promo Banner — slim, animated gradient */}
      {promo && (
        <div
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "linear-gradient(135deg, #801F56 0%, #a83279 50%, #801F56 100%)",
            backgroundSize: "200% 100%",
            animation: "shimmerSlide 6s ease-in-out infinite",
            padding: "6px 16px",
            color: "#fff",
          }}
        >
          <span style={{ fontSize: "13px", fontWeight: 500, letterSpacing: "0.5px" }}>
            ✨ ¡Nos estamos renovando, mantente conectado!
          </span>
          <button
            onClick={() => setPromo(false)}
            style={{
              position: "absolute",
              right: "12px",
              background: "none",
              border: "none",
              color: "rgba(255,255,255,0.7)",
              cursor: "pointer",
              padding: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => { e.target.style.color = "#fff"; e.target.style.backgroundColor = "rgba(255,255,255,0.15)"; }}
            onMouseLeave={(e) => { e.target.style.color = "rgba(255,255,255,0.7)"; e.target.style.backgroundColor = "transparent"; }}
            aria-label="Cerrar promoción"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      )}

      {/* Header — glassmorphism, compact */}
      <header
        style={{
          position: fixedNav ? "fixed" : "relative",
          top: 0,
          left: 0,
          zIndex: 50,
          width: "100%",
          backgroundColor: "rgba(240, 192, 200, 0.92)",
          backdropFilter: "blur(16px) saturate(180%)",
          WebkitBackdropFilter: "blur(16px) saturate(180%)",
          boxShadow: fixedNav ? "0 1px 20px rgba(128, 31, 86, 0.1)" : "none",
          transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
          borderBottom: fixedNav ? "1px solid rgba(128, 31, 86, 0.08)" : "none",
          animation: "fadeInDown 0.5s ease-out",
        }}
      >
        <nav
          style={{
            maxWidth: "1280px",
            margin: "0 auto",
            display: "flex",
            height: fixedNav ? "56px" : "64px",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 24px",
            transition: "height 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
        >
          {/* Logo */}
          <Link to="/" style={{ flexShrink: 0, textDecoration: "none" }}>
            <picture>
              <source
                media="(max-width: 600px)"
                srcSet={require("../../assets/img/merry-md.png")}
              />
              <img
                src={require("../../assets/img/MERRY COLOR D8708E.png") || "/placeholder.svg"}
                alt="Logo"
                style={{
                  height: fixedNav ? "40px" : "48px",
                  width: "auto",
                  objectFit: "contain",
                  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                }}
              />
            </picture>
          </Link>

          {/* Desktop Navigation */}
          <ul
            style={{
              display: "none",
              alignItems: "center",
              gap: "2px",
              listStyle: "none",
              margin: 0,
              padding: 0,
            }}
            className="desktop-nav"
          >
            {filteredNavItems.map((item, i) => (
              <li key={item.name + item.path} style={{ animation: `fadeInDown 0.4s ease ${0.1 * i}s both` }}>
                <Link
                  to={item.path}
                  style={{
                    position: "relative",
                    display: "inline-block",
                    padding: "6px 14px",
                    fontSize: "13px",
                    fontWeight: 600,
                    letterSpacing: "0.3px",
                    color: "#802257",
                    textDecoration: "none",
                    borderRadius: "8px",
                    transition: "all 0.25s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "rgba(128, 34, 87, 0.08)";
                    e.currentTarget.style.transform = "translateY(-1px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>

          {/* Icons */}
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            {/* Person */}
            <Link
              to={autenticado ? "/profile" : "/iniciar-sesion"}
              style={{
                display: "flex",
                height: "36px",
                width: "36px",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                color: "#802257",
                textDecoration: "none",
                transition: "all 0.25s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "rgba(128, 34, 87, 0.1)";
                e.currentTarget.style.transform = "scale(1.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.style.transform = "scale(1)";
              }}
              aria-label="Perfil"
            >
              {autenticado && usuario?.profile_image ? (
                <img
                  src={usuario.profile_image}
                  alt={usuario?.name || "Perfil"}
                  style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover", border: "2px solid #802257" }}
                />
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                </svg>
              )}
            </Link>

            {/* Cart */}
            <Link
              to={autenticado ? "/Carrito-compras" : "/carrito"}
              style={{
                position: "relative",
                display: "flex",
                height: "36px",
                width: "36px",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                color: "#802257",
                textDecoration: "none",
                transition: "all 0.25s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "rgba(128, 34, 87, 0.1)";
                e.currentTarget.style.transform = "scale(1.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.style.transform = "scale(1)";
              }}
              aria-label="Carrito de compras"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
              </svg>
              {cartLength > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: "-2px",
                    right: "-2px",
                    display: "flex",
                    height: "18px",
                    width: "18px",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "50%",
                    backgroundColor: "#801F56",
                    color: "#fff",
                    fontSize: "10px",
                    fontWeight: 700,
                    boxShadow: "0 2px 8px rgba(128, 31, 86, 0.3)",
                    border: "2px solid rgba(255,240,245,0.9)",
                  }}
                >
                  {cartLength}
                </span>
              )}
            </Link>

            {/* Mobile Menu Button */}
            <button
              onClick={() => toggleDrawer(true)}
              style={{
                display: "flex",
                height: "36px",
                width: "36px",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                color: "#802257",
                background: "none",
                border: "none",
                cursor: "pointer",
                marginLeft: "4px",
                transition: "all 0.25s ease",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "rgba(128, 34, 87, 0.1)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
              className="mobile-menu-btn"
              aria-label="Abrir menú"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
              </svg>
            </button>
          </div>
        </nav>
      </header>

      {/* CSS for desktop nav visibility */}
      <style>{`
        .desktop-nav { display: none !important; }
        .mobile-menu-btn { display: flex !important; }
        @media (min-width: 768px) {
          .desktop-nav { display: flex !important; }
          .mobile-menu-btn { display: none !important; }
        }
      `}</style>

      {/* Mobile Drawer Overlay */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 999,
          backgroundColor: "rgba(0,0,0,0.4)",
          backdropFilter: "blur(4px)",
          transition: "opacity 0.3s ease",
          opacity: drawerOpen ? 1 : 0,
          pointerEvents: drawerOpen ? "auto" : "none",
        }}
      />

      {/* Mobile Drawer */}
      <div
        ref={drawerRef}
        style={{
          position: "fixed",
          right: 0,
          top: 0,
          zIndex: 1000,
          display: "flex",
          height: "100%",
          width: "280px",
          flexDirection: "column",
          backgroundColor: "#fff",
          boxShadow: "0 0 40px rgba(0,0,0,0.15)",
          transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          transform: drawerOpen ? "translateX(0)" : "translateX(100%)",
        }}
      >
        {/* Drawer Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid #fce4ec",
            padding: "16px 20px",
          }}
        >
          <span style={{ fontSize: "18px", fontWeight: 700, letterSpacing: "0.5px", color: "#802257" }}>Menú</span>
          <button
            onClick={() => toggleDrawer(false)}
            style={{
              display: "flex",
              height: "32px",
              width: "32px",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              color: "#802257",
              background: "none",
              border: "none",
              cursor: "pointer",
              transition: "background-color 0.2s",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#fce4ec"; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
            aria-label="Cerrar menú"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Drawer Nav Items */}
        <ul style={{ flex: 1, overflowY: "auto", padding: "16px 12px", listStyle: "none", margin: 0 }}>
          {filteredNavItems.map((item) => (
            <li key={item.name + item.path}>
              <Link
                to={item.path}
                onClick={() => toggleDrawer(false)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "12px",
                  padding: "12px 16px",
                  fontSize: "15px",
                  fontWeight: 500,
                  color: "#555",
                  textDecoration: "none",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#fce4ec";
                  e.currentTarget.style.color = "#802257";
                  e.currentTarget.style.paddingLeft = "24px";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.color = "#555";
                  e.currentTarget.style.paddingLeft = "16px";
                }}
              >
                {item.name}
              </Link>
            </li>
          ))}
        </ul>

        {/* Drawer Footer Icons */}
        <div style={{ borderTop: "1px solid #fce4ec", padding: "16px 20px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "16px" }}>
            <Link
              to={autenticado ? "/profile" : "/iniciar-sesion"}
              onClick={() => toggleDrawer(false)}
              style={{
                display: "flex",
                height: "40px",
                width: "40px",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                backgroundColor: "#fce4ec",
                color: "#802257",
                textDecoration: "none",
                transition: "all 0.25s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#802257";
                e.currentTarget.style.color = "#fff";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(128,31,86,0.3)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#fce4ec";
                e.currentTarget.style.color = "#802257";
                e.currentTarget.style.boxShadow = "none";
              }}
              aria-label="Perfil"
            >
              {autenticado && usuario?.profile_image ? (
                <img
                  src={usuario.profile_image}
                  alt={usuario?.name || "Perfil"}
                  style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover", border: "2px solid #fff" }}
                />
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                </svg>
              )}
            </Link>
            <Link
              to={autenticado ? "/Carrito-compras" : "/carrito"}
              onClick={() => toggleDrawer(false)}
              style={{
                position: "relative",
                display: "flex",
                height: "40px",
                width: "40px",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                backgroundColor: "#fce4ec",
                color: "#802257",
                textDecoration: "none",
                transition: "all 0.25s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#802257";
                e.currentTarget.style.color = "#fff";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(128,31,86,0.3)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#fce4ec";
                e.currentTarget.style.color = "#802257";
                e.currentTarget.style.boxShadow = "none";
              }}
              aria-label="Carrito"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
              </svg>
              {cartLength > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: "-4px",
                    right: "-4px",
                    display: "flex",
                    height: "18px",
                    width: "18px",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "50%",
                    backgroundColor: "#801F56",
                    color: "#fff",
                    fontSize: "10px",
                    fontWeight: 700,
                    boxShadow: "0 2px 6px rgba(128,31,86,0.3)",
                    border: "2px solid #fff",
                  }}
                >
                  {cartLength}
                </span>
              )}
            </Link>
          </div>
        </div>
      </div>

      {/* Spacer when nav is fixed to prevent content jump */}
      {fixedNav && <div style={{ height: "56px" }} />}
    </>
  );
};
